import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col sm:flex-row items-center justify-between gap-3 pt-4 pb-2"
}
const _hoisted_2 = {
  class: "text-xs",
  style: {"color":"#6b7280"}
}
const _hoisted_3 = {
  class: "font-semibold",
  style: {"color":"#111827"}
}
const _hoisted_4 = {
  class: "font-semibold",
  style: {"color":"#111827"}
}
const _hoisted_5 = {
  class: "font-semibold",
  style: {"color":"#111827"}
}
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3.5 h-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "px-2 text-xs",
  style: {"color":"#9ca3af"}
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3.5 h-3.5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    modelValue: null,
    perPage: null,
    totalItems: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', page: number): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: number;
  perPage: number;
  totalItems: number;
};





const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage));

const from = computed(() => Math.min((props.modelValue - 1) * props.perPage + 1, props.totalItems));
const to   = computed(() => Math.min(props.modelValue * props.perPage, props.totalItems));

const pageRange = computed<(number | '...')[]>(() => {
  const total = totalPages.value;
  const cur   = props.modelValue;

  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages: (number | '...')[] = [1];

  if (cur > 3) pages.push('...');

  const start = Math.max(2, cur - 1);
  const end   = Math.min(total - 1, cur + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (cur < total - 2) pages.push('...');
  pages.push(total);

  return pages;
});

return (_ctx: any,_cache: any) => {
  return (_unref(totalPages) > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" Showing "),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(from)), 1),
          _createTextVNode(" – "),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(to)), 1),
          _createTextVNode(" of "),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.totalItems), 1),
          _createTextVNode(" entries ")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            disabled: __props.modelValue <= 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', __props.modelValue - 1))),
            class: "flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-lg transition-colors",
            style: _normalizeStyle(__props.modelValue <= 1
          ? 'background:#f3f4f6; color:#9ca3af; cursor:not-allowed; border:1px solid #f3f4f6;'
          : 'background:#fff; color:#374151; cursor:pointer; border:1px solid #e5e7eb;')
          }, [
            _hoisted_8,
            _createTextVNode(" Prev ")
          ], 12, _hoisted_7),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageRange), (p) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: p }, [
              (p === '...')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "…"))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: ($event: any) => (emit('update:modelValue', p as number)),
                    class: "min-w-[2rem] h-8 text-xs font-medium rounded-lg transition-colors",
                    style: _normalizeStyle(p === __props.modelValue
            ? 'background:#6CC551; color:#fff; border:1px solid #6CC551; cursor:default;'
            : 'background:#fff; color:#374151; border:1px solid #e5e7eb; cursor:pointer;')
                  }, _toDisplayString(p), 13, _hoisted_10))
            ], 64))
          }), 128)),
          _createElementVNode("button", {
            disabled: __props.modelValue >= _unref(totalPages),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', __props.modelValue + 1))),
            class: "flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-lg transition-colors",
            style: _normalizeStyle(__props.modelValue >= _unref(totalPages)
          ? 'background:#f3f4f6; color:#9ca3af; cursor:not-allowed; border:1px solid #f3f4f6;'
          : 'background:#fff; color:#374151; cursor:pointer; border:1px solid #e5e7eb;')
          }, [
            _createTextVNode(" Next "),
            _hoisted_12
          ], 12, _hoisted_11)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})